import { ActionType } from '../../constants/ActionTypes';
import config from '../../constants/Configs';
import { RestPath } from '../../constants/SitePaths';
import { Constants } from '../../constants/Constants';
import axios from 'axios';
import NotificationService from '../../components/base/notifications/NotificationService'
import { ErrorHelper } from '../../services/helpers/error/ErrorHelper';



// Get notification preferences
export const getNotificationPreferencesBegin = () => ({
    type: ActionType.GET_NOTIFICATION_PREFERENCES_BEGIN,
});

export const getNotificationPreferencesError = (data) => ({
    type: ActionType.GET_NOTIFICATION_PREFERENCES_ERROR,
    payload: data
});

export const getNotificationPreferencesSuccess = (data) => ({
    type: ActionType.GET_NOTIFICATION_PREFERENCES_SUCCESS,
    payload: data
});
export const setNotificationPreferencesBegin = () => ({
    type: ActionType.SET_NOTIFICATION_PREFERENCES_BEGIN,
});
export const setNotificationPreferencesError = (data) => ({
    type: ActionType.SET_NOTIFICATION_PREFERENCES_ERROR,
    payload: data
});

export const setNotificationPreferencesSuccess = (data) => ({
    type: ActionType.SET_NOTIFICATION_PREFERENCES_SUCCESS,
    payload: data
});

export const getNotificationPreferencesRulesBegin = () => ({
    type: ActionType.GET_NOTIFICATION_PREFERENCES_RULES_BEGIN,
});

export const getNotificationPreferencesRulesError = (data) => ({
    type: ActionType.GET_NOTIFICATION_PREFERENCES_RULES_ERROR,
    payload: data
});

export const getNotificationPreferencesRulesSuccess = (data) => ({
    type: ActionType.GET_NOTIFICATION_PREFERENCES_RULES_SUCCESS,
    payload: data
});

export const accountClosureBegin = () => ({
    type: ActionType.ACCOUNT_CLOSURE_BEGIN,
});
export const accountClosureSuccess = () => ({
    type: ActionType.ACCOUNT_CLOSURE_SUCCESS,
});
export const accountClosureError = () => ({
    type: ActionType.ACCOUNT_CLOSURE_ERROR,
});
export const getTimeLimitBegin = () => ({
    type: ActionType.GET_TIME_LIMIT_BEGIN,
});
export const getTimeLimitError = () => ({
    type: ActionType.GET_TIME_LIMIT_ERROR,
});
export const getTimeLimitSuccess = (data) => ({
    type: ActionType.GET_TIME_LIMIT_SUCCESS,
    payload: data
});
export const getDepositLimitBegin = () => ({
    type: ActionType.GET_DEPOSIT_LIMIT_BEGIN,
});
export const getDepositLimitError = () => ({
    type: ActionType.GET_DEPOSIT_LIMIT_ERROR,
});
export const getDepositLimitSuccess = (data) => ({
    type: ActionType.GET_DEPOSIT_LIMIT_SUCCESS,
    payload: data
});
export const getBetLimitBegin = () => ({
    type: ActionType.GET_BET_LIMIT_BEGIN,
});
export const getBetLimitError = () => ({
    type: ActionType.GET_BET_LIMIT_ERROR,
});
export const getBetLimitSuccess = (data) => ({
    type: ActionType.GET_BET_LIMIT_SUCCESS,
    payload: data
});
export const getSingleBetBegin = () => ({
    type: ActionType.GET_SINGLE_BET_BEGIN,
});
export const getSingleBetError = () => ({
    type: ActionType.GET_SINGLE_BET_ERROR,
});
export const getSingleBetSuccess = (data) => ({
    type: ActionType.GET_SINGLE_BET_SUCCESS,
    payload: data
});
export const setSingleBetBegin = () => ({
    type: ActionType.SET_SINGLE_BET_BEGIN,
});
export const setSingleBetError = () => ({
    type: ActionType.SET_SINGLE_BET_ERROR,
});
export const setSingleBetSuccess = (data) => ({
    type: ActionType.SET_SINGLE_BET_SUCCESS,
    payload: data
});
export const getTimeOutBegin = () => ({
    type: ActionType.GET_TIME_OUT_BEGIN,
});
export const getTimeOutError = () => ({
    type: ActionType.GET_TIME_OUT_ERROR,
});
export const getTimeOutSuccess = (data) => ({
    type: ActionType.GET_TIME_OUT_SUCCESS,
    payload: data
});

export const getSelfExclusionBegin = () => ({
    type: ActionType.GET_SELF_EXCLUSION_BEGIN,
});
export const getSelfExclusionError = () => ({
    type: ActionType.GET_SELF_EXCLUSION_ERROR,
});
export const getSelfExclusionSuccess = (data) => ({
    type: ActionType.GET_SELF_EXCLUSION_SUCCESS,
    payload: data
});
export const getExclusionReasonsBegin = () => ({
    type: ActionType.GET_EXCLUSION_REASONS_BEGIN,
});
export const getExclusionReasonsError = () => ({
    type: ActionType.GET_EXCLUSION_REASONS_ERROR,
});
export const getExclusionReasonsSuccess = (data, section) => ({
    type: ActionType.GET_EXCLUSION_REASONS_SUCCESS,
    payload: data,
    section: section
});
export const getAccessLimitBegin = () => ({
    type: ActionType.GET_ACCESS_LIMIT_BEGIN,
});
export const getAccessLimitError = () => ({
    type: ActionType.GET_ACCESS_LIMIT_ERROR,
});
export const getAccessLimitSuccess = (data) => ({
    type: ActionType.GET_ACCESS_LIMIT_SUCCESS,
    payload: data
});

export const getAccessLimitOverviewBegin = () => ({
    type: ActionType.GET_ACCESS_LIMIT_OVERVIEW_BEGIN,
});
export const getAccessLimitOverviewError = () => ({
    type: ActionType.GET_ACCESS_LIMIT_OVERVIEW_ERROR,
});
export const getAccessLimitOverviewSuccess = (data) => ({
    type: ActionType.GET_ACCESS_LIMIT_OVERVIEW_SUCCESS,
    payload: data
});

export const getAccessLimitPendingBegin = () => ({
    type: ActionType.GET_ACCESS_LIMIT_PENDING_BEGIN,
});
export const getAccessLimitPendingError = () => ({
    type: ActionType.GET_ACCESS_LIMIT_PENDING_ERROR,
});
export const getAccessLimitPendingSuccess = (data) => ({
    type: ActionType.GET_ACCESS_LIMIT_PENDING_SUCCESS,
    payload: data
});


export const getRealityCheckBegin = () => ({
    type: ActionType.GET_REALITY_CHECK_BEGIN,
});
export const getRealityCheckError = () => ({
    type: ActionType.GET_REALITY_CHECK_ERROR,
});
export const getRealityCheckSuccess = (data) => ({
    type: ActionType.GET_REALITY_CHECK_SUCCESS,
    payload: data
});

export const getLossLimitBegin = () => ({
    type: ActionType.GET_LOSS_LIMIT_BEGIN,
});
export const getLossLimitError = () => ({
    type: ActionType.GET_LOSS_LIMIT_ERROR,
});
export const getLossLimitSuccess = (data) => ({
    type: ActionType.GET_LOSS_LIMIT_SUCCESS,
    payload: data
});

export const setLossLimitBegin = () => ({
    type: ActionType.SET_LOSS_LIMIT_BEGIN,
});
export const setLossLimitError = () => ({
    type: ActionType.SET_LOSS_LIMIT_ERROR,
});
export const setLossLimitSuccess = (data) => ({
    type: ActionType.SET_LOSS_LIMIT_SUCCESS,
    payload: data
});

export const setPromptLimitsData = (data) => ({
    type: ActionType.SET_PROMPT_LIMITS,
    payload: data
});

export function getNotificationPreferences() {
    return dispatch => {
        dispatch(getNotificationPreferencesBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.NOTIFICATION_PREFERENCES}`
        }).then((response) => {
            dispatch(getNotificationPreferencesSuccess(response.data));
            return response.data
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getNotificationPreferencesError(error.response.data));
                } else {
                    dispatch(getNotificationPreferencesError(error));
                }

            });
    };
}

export function setNotificationPreferences(data) {
    return dispatch => {
        dispatch(setNotificationPreferencesBegin());
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.NOTIFICATION_PREFERENCES}`,
            data
        }).then((response) => {
            dispatch(setNotificationPreferencesSuccess(response.data));
            // NotificationService.success({ message: response.data.message });
            return response.data;
        })
            .catch((error) => {
                // NotificationService.error({ message: response.data.message });
                if (error.response) {
                    dispatch(setNotificationPreferencesError(error.response.data));
                } else {
                    dispatch(setNotificationPreferencesError(error));
                }

            });
    };
}

export function getNotificationPreferencesRules() {
    return dispatch => {
        dispatch(getNotificationPreferencesRulesBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.NOTIFICATION_PREFERENCES_RULES}`
        }).then((response) => {
            dispatch(getNotificationPreferencesRulesSuccess(response.data));
            return response.data
        })
            .catch((error) => {
                if (error.response) {
                    dispatch(getNotificationPreferencesRulesError(error.response.data));
                } else {
                    dispatch(getNotificationPreferencesRulesError(error));
                }
            });
    };
}

export function send2FACode(data) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.SEND_2FA_CODE}`,
            data
        }).then((response) => {
            // dispatch(send2FACodeSuccess(response.data));
            // NotificationService.success({ message: response.data.message });
        }).catch((error) => {
            NotificationService.error({ message: ErrorHelper.getMessage(error) });
        });
    };
}
export function send2FACodeForLoggedInUser(data) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.SEND_LOGGEDIN_USER_2FA_CODE}`,
            data
        }).then((response) => {
            // dispatch(send2FACodeSuccess(response.data));
            // NotificationService.success({ message: response.data.message });
        }).catch((error) => {
            NotificationService.error({ message: ErrorHelper.getMessage(error) });
        });
    };
}


export function accountClosure(data, successMessage) {
    return dispatch => {
        dispatch(accountClosureBegin());
        return axios({
            method: Constants.DELETE,
            url: `${config.BASE_URL}${RestPath.ACCOUNT_CLOSURE}`,
            data
        }).then((response) => {
            dispatch(accountClosureSuccess());
            // dispatch(sendAccountClosureCodeSuccess(response.data));
            NotificationService.success({ message: successMessage });
            return true;
        }).catch((error) => {
            dispatch(accountClosureError());
            NotificationService.error({ message: ErrorHelper.getMessage(error) });
        });
    };
}


export function getTimeLimit(data) {
    return dispatch => {
        dispatch(getTimeLimitBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.TIME_LIMIT}`,
            params: data
        }).then((response) => {
            dispatch(getTimeLimitSuccess(response.data));
        })
            .catch((error) => {
                dispatch(getTimeLimitError());
            });
    };
}

export function editTimeLimit(data, successMessage) {
    return dispatch => {
        dispatch(getTimeLimitBegin());
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.TIME_LIMIT}`,
            data
        }).then((response) => {
            NotificationService.success({ message: successMessage });
            dispatch(getTimeLimitSuccess(response.data));
            return true;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }

            dispatch(getTimeLimitError());
        });
    };
}

export function getDepositLimit(data) {
    return dispatch => {
        dispatch(getDepositLimitBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.DEPOSIT_LIMIT}`,
            params: data
        }).then((response) => {
            dispatch(getDepositLimitSuccess(response.data));
        })
            .catch((error) => {
                dispatch(getDepositLimitError());
            });
    };
}
export function editDepositLimit(data, successMessage) {
    return dispatch => {
        dispatch(getDepositLimitBegin());
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.DEPOSIT_LIMIT}`,
            data
        }).then((response) => {
            NotificationService.success({ message: successMessage });
            dispatch(getDepositLimitSuccess(response.data));
            return true;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }

            dispatch(getDepositLimitError());
        });
    };
}
export function getBetLimit(data) {
    return dispatch => {
        dispatch(getBetLimitBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.BET_LIMIT}`,
            params: data
        }).then((response) => {
            dispatch(getBetLimitSuccess(response.data));
        })
            .catch((error) => {
                dispatch(getBetLimitError());
            });
    };
}
export function editBetLimit(data, successMessage) {
    return dispatch => {
        dispatch(getBetLimitBegin());
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.BET_LIMIT}`,
            data
        }).then((response) => {
            NotificationService.success({ message: successMessage });
            dispatch(getBetLimitSuccess(response.data));
            return true;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }

            dispatch(getBetLimitError());
        });
    };
}

export function getTimeOut() {
    return dispatch => {
        dispatch(getTimeOutBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_TIME_OUT}`
        }).then((response) => {
            dispatch(getTimeOutSuccess(response.data));
        }).catch((error) => {
            dispatch(getTimeOutError());
        });
    };
}
export function setTimeOut(data, successMessage) {
    return dispatch => {

        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.SET_TIME_OUT}`,
            data
        }).then((response) => {
            NotificationService.success({ message: successMessage });
            return true;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }
            dispatch(getTimeOutError());
        });
    };
}
export function getSingleBet(data) {
    return dispatch => {
        dispatch(getSingleBetBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.SINGLE_BET}`,
            data
        }).then((response) => {
            dispatch(getSingleBetSuccess(response.data));
            return response.data;
        }).catch((error) => {
            dispatch(getSingleBetError());
        });
    };
}
export function setSingleBet(data) {
    return dispatch => {
        dispatch(setSingleBetBegin());
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.SINGLE_BET}`,
            data
        }).then((response) => {
            dispatch(setSingleBetSuccess(response.data));
            return response.data;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }
            dispatch(setSingleBetError());
        });
    };
}
export function setSelfExclusion(data, successMessage) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.SET_SELF_EXCLUSION}`,
            data
        }).then((response) => {
            NotificationService.success({ message: successMessage });
            return true;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }
            dispatch(getSelfExclusionError());
        });
    };
}
export function getSelfExclusion(data) {
    return dispatch => {
        dispatch(getSelfExclusionBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_SELF_EXCLUSION}`,
            params: data
        }).then((response) => {
            dispatch(getSelfExclusionSuccess(response.data));
        }).catch((error) => {
            dispatch(getSelfExclusionError());
        });
    };
}

export function getExclusionReasons(reason) {
    return dispatch => {
        dispatch(getExclusionReasonsBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.EXCLUSION_REASONS}`,
            params: { reasonAction: reason.key }
        }).then((response) => {
            dispatch(getExclusionReasonsSuccess(response.data, reason.action));
            return true;
        })
            .catch((error) => {
                dispatch(getExclusionReasonsError());
            });
    };
}

export function getRealityCheck(data) {
    return dispatch => {
        dispatch(getRealityCheckBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.GET_REALITY_CHECK}`
        }).then((response) => {
            dispatch(getRealityCheckSuccess({ ...response.data, ...data }));
            return response.data
        }).catch(() => {
            dispatch(getRealityCheckError());
        });
    };
}

export function setRealityCheck(data) {
    return dispatch => {

        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.SET_REALITY_CHECK}`,
            data
        }).then((response) => {
            return true;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }
            dispatch(getBetLimitError());
        });
    };
}

export function getAccessLimit(data) {
    return dispatch => {
        dispatch(getAccessLimitBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.ACCESS_LIMIT}`,
            params: data
        }).then((response) => {
            dispatch(getAccessLimitSuccess(response.data));
            return response.data
        })
            .catch((error) => {
                dispatch(getAccessLimitError());
            });
    };
}

export function setAccessLimit(data, successMessage) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.ACCESS_LIMIT}`,
            data
        }).then((response) => {
            NotificationService.success({ message: successMessage });
            return response;
        })
            .catch((error) => {
                if (error.response) {
                    NotificationService.error({ message: ErrorHelper.getMessage(error) });
                }
            });
    };
}

export function getAccessLimitOverview(data) {
    return dispatch => {
        dispatch(getAccessLimitOverviewBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.ACCESS_LIMIT_OVERVIEW}`,
            params: data
        }).then((response) => {
            dispatch(getAccessLimitOverviewSuccess(response.data));
        })
            .catch((error) => {
                dispatch(getAccessLimitOverviewError());
            });
    };
}

export function getAccessLimitPending(data) {
    return dispatch => {
        dispatch(getAccessLimitPendingBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.ACCESS_LIMIT_PENDING}`,
            params: data
        }).then((response) => {
            dispatch(getAccessLimitPendingSuccess(response.data));
        })
            .catch((error) => {
                dispatch(getAccessLimitPendingError());
            });
    };
}

export function getLossLimit(data) {
    return dispatch => {
        dispatch(getLossLimitBegin());
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.LOSS_LIMIT}`,
            params: data
        }).then((response) => {
            dispatch(getLossLimitSuccess(response.data));
            return response.data
        })
            .catch((error) => {
                dispatch(getLossLimitError());
            });
    };
}

export function setLossLimit(data, successMessage) {
    return dispatch => {
        dispatch(setLossLimitBegin());
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.LOSS_LIMIT}`,
            data
        }).then((response) => {
            NotificationService.success({ message: successMessage });
            dispatch(setLossLimitSuccess(response.data));
            return true;
        }).catch((error) => {
            if (error.response) {
                NotificationService.error({ message: ErrorHelper.getMessage(error) });
            }
            dispatch(setLossLimitError());
        });
    };
}

export function setPromptLimits(data) {
    return dispatch => {
        return axios({
            method: Constants.POST,
            url: `${config.BASE_URL}${RestPath.PROMPT_LIMIT}`,
            data
        }).then((response) => {
            dispatch(setPromptLimitsData(data))
            return response;
        }).catch((error) => {
            NotificationService.error({ message: ErrorHelper.getMessage(error) });
        });
    };
}

export function getLimitPredifinedValues(data) {
    return dispatch => {
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.LIMIT_PREDIFINED_VALUES}`,
            data
        }).then((response) => {
            return response
        }).catch((error) => {
        });
    };
}

export function getSessionInformation() {
    return dispatch => {
        return axios({
            method: Constants.GET,
            url: `${config.BASE_URL}${RestPath.SESSION_INFORMATION}`
        }).then((response) => {
            return response.data
        }).catch((error) => {
            console.log(error)
        });
    };
}
